{
    "UploadfilesFilename": "Nome do ficheiro",
    "UploadfilesFilesize": "Tamanho do ficheiro",
    "UploadfilesEmailserroredsendingseebelow": "Clique para mais informações",
    "UploadfilesSuccesswitherrorparagraph": "Seus utilizadores foram configurados. No entanto, ocorreu um erro ao enviar e-mails de boas-vindas.",
    "Resulttableheaderusername": "Nome de utilizador",
    "Resulttableheaderemail": "Endereço de email",
    "Resulttableheaderrptaccess": "Acesso a relatórios",
    "Resulttableheaderisadmin": "é administrador?",
    "Resulttableheaderisocagent": "O agente é OC?",
    "Resulttableheaderenhancemobileapp": "Aplicação móvel aprimorada?",
    "LanguageBulkInsertUsers_UploadfilesHeader1": "Utilizadores de upload em massa",
    "LanguageBulkInsertUsers_UploadfilesSubheader1": "Importar ficheiro.",
    "LanguageBulkInsertUsers_UploadfilesButton1": "Começar",
    "LanguageBulkInsertUsers_UploadfilesSubheader2": "Em processamento.",
    "LanguageBulkInsertUsers_UploadfilesButton2": "Voltar",
    "LanguageBulkInsertUsers_UploadfilesButton3": "confirme",
    "LanguageBulkInsertUsers_UploadfilesSubheader3": "Importar.",
    "LanguageBulkInsertUsers_UploadfilesSubheader4": "Ops.",
    "LanguageBulkInsertUsers_UploadfilesSubheader5": "Confirmação.",
    "LanguageBulkInsertUsers_UploadfilesSubheader6": "Sucesso.",
    "LanguageBulkInsertUsers_UploadfilesButton4": "Feito",
    "LanguageBulkInsertUsers_UploadfilesSuccessparagraph1": "Configurámos com sucesso os seus utilizadores.",
    "LanguageBulkInsertUsers_UploadfilesStarttextpart1": "Comece por descarregar e preencher o",
    "LanguageBulkInsertUsers_UploadfilesStarttextbutton": "Modelo CSV",
    "LanguageBulkInsertUsers_UploadfilesStarttextpart2": "fornecido.",
    "LanguageBulkInsertUsers_UploadfilesConfirmationtext": "Confirme se tudo foi digitado corretamente e prossiga para importar o ficheiro completo aqui (Quaisquer erros com o ficheiro serão detetados durante a configuração):",
    "LanguageBulkInsertUsers_UploadfilesChoosefile": "Escolher ficheiro",
    "LanguageBulkInsertUsers_UploadfilesDraganddrop": "ou arraste e solte aqui.",
    "LanguageBulkInsertUsers_UploadfilesDrophere": "Solte seus ficheiros aqui...",
    "LanguageBulkInsertUsers_UploadfilesFiledetails": "Detalhes do ficheiro:",
    "LanguageBulkInsertUsers_PromptdefaultcloseMessage": "Tem certeza de que deseja fechar a janela e perder o progresso?",
    "LanguageBulkInsertUsers_PromptdefaultcloseConfirm": "Sim",
    "LanguageBulkInsertUsers_PromptdefaultcloseCancel": "Cancelar",
    "LanguageBulkInsertUsers_ValidationError": "Erro: não foi possível processar o pedido de aprovisionamento em massa. Veja abaixo mais informações.",
    "LanguageBulkInsertUsers_SuccessTitle": "Verifique suas alterações e confirme.",
    "LanguageBulkInsertUsers_InvalidfileformatError": "Erro: formato de ficheiro inválido, use nosso modelo CSV.",
    "LanguageBulkInsertUsers_MaxfilesizeError": "Erro: o tamanho máximo do ficheiro foi excedido. Máximo de 10 MB permitidos.",
    "NAME": "LanguageBulkInsertUsers"
}